import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsDvcsBitbucketRoute: InvariantJiraRoute = {
	name: 'global-settings-products-dvcs-bitbucket',
	path: '/secure/BitbucketPostInstallApprovalAction.jspa',
};
